/**
 * @constant
 */
const TableNames = {
    EVENTS: "Events",
    ANIMALS: "Animals",
    TG: "TechnoGroups",
    AG: "AnimalsGroup",
    NOTIFI: "Notifications",
    DEVICES: "Devices",
    DICTIONARY: "Dictionary",
    USERS: "Users",
    ROLES: "Roles",
    LOGS: "Logs",
    CH: "CommandsHistory",
    DOCS: "Documents",
    AGGDATA: "AggData",
    SETTINGS: "Settings",
    ATHENA: "AthenaQueries",
    MAINTENANCE: "Maintenance",
    CLIENTS: "Clients",
    BUILDINGS: "Buildings",
    LICENSE: "License",
    SILOS: "Silos",
    ITS: "ITS",
    FILES: "Files",
    CC: "CodeCommitPR",
    VER: "Versions",
    FTI: "FarmTimeInterval",
    REGISTRATION: "Registration",
    SALES: "Sales",
    PREFERENCES: "PersonalSettings",
    ECONOMY: "Economy",
    SCHEDULE_NOTIFICATIONS: "ScheduleNotifications",
    PRESENCE: "Presence",
    JOBS: "JobsHistory",
    STOREHOUSE: "Storehouse",
    EC2: "EC2Scheduler",
    PROCESS_OCR: "ProcessOCR",
    WORKING_COPY: "WorkingCopy",
    SERIAL: "Serial",
    PCB: "PCB",
    OFFLINE: "Offline",
    TRANSLATIONS: "Translations",
    BREEDING_COUNTERS: "BreedingCounters",
    PROJECT: "Projects",
    ALARMS: "Alarms",
    ALARMS_HISTORY: "AlarmsHistory",
    PAYMENTS: "Payments",
    LICENCE: "Licence",
    ALARMS_CDR: "AlarmsCDRAgg",
    PUSH_NOTIFICATIONS: "PushNotifications"

};

module.exports = TableNames;
